import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take, debounce, debounceTime } from 'rxjs/operators';
import { Validation, ContractType, PersonType, PredictZipCodeModel } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { CustomerJourneyService } from '../data/customer-journey.service';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class PostalCodeValidationService {
  constructor(private customerJourneyService: CustomerJourneyService, private gtmDataLayerUiService: GtmDatalayerUiService) {

  }
  postalCodeValidSubject: Subject<Validation> = new Subject<Validation>();
  postalCodeValid$ = this.postalCodeValidSubject.asObservable();

  provinceSubject: Subject<PredictZipCodeModel> = new Subject<PredictZipCodeModel>();
  province$ = this.provinceSubject.asObservable();
  isvalidZip = false;
  isInValid(contractType: ContractType): boolean {
    let validation = this.postalCodeValidation(contractType)
    this.setError(validation);
    return validation.isInValid;
  }
  private postalCodeValidation(contractType: ContractType): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (contractType.postalCode == null || contractType.postalCode == undefined || contractType.postalCode == '' || !this.isvalidZip) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.postalCode)
    }
    return validation;
  }

  predictZipCode(postalCode: string) {
    if (postalCode.length > 3) {
      this.customerJourneyService.predictZipCode(postalCode).pipe(debounceTime(1000)).subscribe(res => {
        let validation: Validation = new Validation();
        console.log(res, postalCode)
        validation.isInValid = false;
        if (res == null && postalCode != "") {
          validation.isInValid = true;
          validation.errorCss = CssClass.error;
          this.isvalidZip = false;
        }
        else {
          this.provinceSubject.next(res);
          validation.isInValid = false;
          this.isvalidZip = true;
        }
        this.setError(validation);
      })
    }
    else {
      let validation: Validation = new Validation();
      validation.isInValid = false;
        validation.isInValid = true;
        validation.errorCss = CssClass.error;
        this.isvalidZip = false;
      this.provinceSubject.next(null);
      this.setError(validation);
    }
  }
  setError(error: Validation) {
    this.postalCodeValidSubject.next(error);
  }
}
